export default {"src":"/_next/static/media/logo-central-da-grama.bc545671.svg","height":39,"width":50};